import {
  Button,
  InputAdornment,
  TextField,
  IconButton,
} from "@material-ui/core";
import MContentIcon from "../../assets/images/icon.png";
import BigNumber from "bignumber.js";
import VerticleLine from "../../assets/svgs/verticalLine.svg";
import SwapIcon from "../../assets/svgs/swapIcon.svg";
import EthereumLogo from "../../assets/svgs/ethereumLogo2.svg";
import BinanceLogo from "../../assets/svgs/binanceLogo.svg";
import React, { useState, useEffect } from "react";
import useStyles from "./createStyles";
import ConnectWalletButton from "../../components/Buttons/ConnectWallet/ConnectWalletButton";
import ConnectWalletModal from "../../components/Modals/ConnectWalletModal/ConnectWalletModal";
import { UnsupportedChainIdError, useWeb3React } from "@web3-react/core";
import Web3 from "web3";
import {
  TOKEN_ERC20,
  TOKEN_BEP20,
  BRIDGE_ERC20,
  BRIDGE_BEP20,
  BRIDGE_BEP20_ABI,
  BRIDGE_ERC20_ABI,
  TOKEN_BEP20_ABI,
  TOKEN_ERC20_ABI,
  supportedChains,
} from "../../contract/constant";
import { switchNetwork } from "../../utils/web3Connectors";
import millify from "millify";
import TransactionInProgress from "../../components/Modals/TransactionProcessing/TransactionInProgress";
import TransactionSuccessfull from "../../components/Modals/TransactionProcessing/TransactionSuccessfull";
import TransactionError from "../../components/Modals/TransactionProcessing/TransactionError";
import DepositeButton from "../../components/Buttons/Deposite/DepositeButton";
import { InjectedConnector } from "@web3-react/injected-connector";
import WrongNetworkModal from "../../components/Modals/WrongNetwork/WrongNetworkModal";


function Create({sendToClaim, isApproving, setIsApproving, setClaims, claims , getClaimableAssets, triggerTransaction, setTriggerTransaction}) {
  const classes = useStyles();
  const { connector, chainId, active, account, library , activate} = useWeb3React();

  const [open, setOpen] = useState(false);
  const [checkApprovalButton, setCheckApprovalButton] = useState(true);
  const [value, setValue] = useState("");
  const [receivingAddress, setReceivingAddress] = useState(account);
  const [invalidReceiving,setInvalidReceiving] = useState(false);
  const [isApprovedERC, setIsApprovedERC] = useState(0);
  const [gasPrice, setGasPrice] = useState(0.0);
  const [isApprovedBEP, setIsApprovedBEP] = useState(0);
  const [transactionInProgress, setTransactionInProgress] = useState(false);
  const [transactionCompleted, setTransationCompleted] = useState(false);
  const [approveLoading, setApproveLoading] = useState(false);
  const [transactionHash, setTransactionHash] =useState("");
  const [mContentBalance, setMContentBalance] = useState(0.0);
  const [pendingTransaction, setPendingTransaction] = useState(false);
  const [transactionError, setTransactionError] = useState(false);
  const [wrongNetwork, setWrongNetwork] = useState(false)
  const [wrongNetworkOpen, setWrongNetworkOpen] = useState(false);
  const [taxPercentage, setTaxPercentage] = useState(0);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  useEffect(async ()=>{
    
  },[account, active, chainId])
  const calculateTaxFee = async () =>{
    const web3 = new Web3(new Web3.providers.HttpProvider("https://speedy-nodes-nyc.moralis.io/0676906f814449c55f778a3a/bsc/mainnet"))
    const contract = new web3.eth.Contract(TOKEN_BEP20_ABI, TOKEN_BEP20);
              let taxFee = await contract.methods._taxFee().call()
              let liquidityFee = await contract.methods._liquidityFee().call();
              let contentFee = await contract.methods._contentFee().call();
              return parseFloat(taxFee) + parseFloat(liquidityFee) + parseFloat(contentFee);
            }
  //coingecko URLS for coins value in usd
  const binanceValueURL =
    "https://api.coingecko.com/api/v3/simple/price?ids=binancecoin&vs_currencies=usd";
  const ethereumValueURL =
    "https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd";

  const getCurrentGasPrices = async () => {
    let bridgeABI = chainId == supportedChains[0] ? BRIDGE_ERC20_ABI : BRIDGE_BEP20_ABI;
    let bridgeTokenAddress = chainId == supportedChains[0] ? BRIDGE_ERC20 : BRIDGE_BEP20;
    try {
      const fetchData = async (URL) => {
        try {
          const response = await fetch(URL);
          const data = await response.json();
          if (data) {
            return chainId ==supportedChains[0]
              ? parseFloat(data.ethereum.usd)
              : parseFloat(data.binancecoin.usd);
          }
          return 0;
        } catch (e) {
          return parseFloat(0);
        }
      };
      //fetchData will fetch the usd price for given url (url varies with respect to chainId)
      let price = await fetchData(
        chainId == supportedChains[0] ? ethereumValueURL : binanceValueURL
      );      
      //initialize web3
      const web3 = new Web3(library?.currentProvider);
      //get the information of latest block
      const latestBlock = await web3.eth.getBlock("latest");
      //extract gas limit from latest block
      const blockGas = chainId == supportedChains[0]?await web3.eth.getGasPrice() :await web3.eth.getBlock("latest").then((latestBlock)=>{
        return latestBlock.gasLimit
      });
      //initialize bridge contract
      const contract = new web3.eth.Contract(bridgeABI, bridgeTokenAddress);
      //initilize token contract to check approval on respected tokens
      const tokenContract =
      chainId === supportedChains[0]
      ? new web3.eth.Contract(TOKEN_ERC20_ABI, TOKEN_ERC20)
      : new web3.eth.Contract(TOKEN_BEP20_ABI, TOKEN_BEP20);
      //function to estimate for both chains
      let estimatedFunction =
        chainId == supportedChains[0]
          ? isApprovedERC != 0
            ? contract.methods.depositTokens(
                value == ""
                  ? web3.utils.toWei("0.1", "mwei")
                  : web3.utils.toWei(value.toString(), "mwei"),
                account.toLowerCase()
              )
            : tokenContract.methods.approve(
                BRIDGE_ERC20,
                web3.utils.toWei("10000000000000000000000000000000000000000")
              )
          : isApprovedBEP != 0
          ? contract.methods.depositTokens(
              value == ""
                ? web3.utils.toWei("0.1", "mwei")
                : web3.utils.toWei(value.toString(), "mwei"),
              account.toLowerCase()
            )
          : tokenContract.methods.approve(
              BRIDGE_BEP20,
              web3.utils.toWei("10000000000000000000000000000000000000000")
            );

      //getting the gas limit from estimate gas web3 function
      const gasLimit = await estimatedFunction.estimateGas({
        from: account,
        gasLimit: blockGas
      });
      //multiplying latest gas limit with estimated gas
      const finalGas = blockGas * gasLimit;
      //converting product of gas to ether'
      const finalGasInEther = await web3.utils.fromWei(
        finalGas.toString(),
        "ether"
      );
      //converting gas to usd
      const decimal = chainId == supportedChains[0]?Number(1):Number(100);
      const USDResult = (Number(finalGasInEther) * price) *decimal;
      //done
      setGasPrice(
        millify(new BigNumber(USDResult).valueOf(), {
          precision: 4,
          lowercase: false,
        })
      );
    } catch (e) {
      return 0.0;
    }
  };

  useEffect(async () => {
    if(!checkApprovalButton){
      await getCurrentGasPrices();
    }
    setReceivingAddress(account);
  }, [account, chainId, checkApprovalButton]);


  useEffect(() => {
    // const wallet = window.localStorage.getItem("previousWallet");
    // if(wallet == "metaMask" || wallet == "walletConnect"){
    // walletTextFunction();
    // }
    setValue("");
    setCheckApprovalButton(true);
  }, [chainId]);


  // const walletTextFunction = () =>{
  //   activate(
  //     connector
  //       ? connector
  //       : new InjectedConnector({
  //           // supportedChainIds: [1, 4],
  //           supportedChainIds: supportedChains,
  //         }),
  //     undefined,
  //     true
  //   ).then(()=>{
  //     setWrongNetwork(false)
  //   }).catch((e)=>{
  //     console.log(e)
  //     if(e instanceof UnsupportedChainIdError){
  //       setWrongNetwork(true)
  //     }
  //     })
  // }
  const checkApproval = async () => {
    if (chainId ==supportedChains[0] || chainId == supportedChains[1]) {
      setCheckApprovalButton(true);
      const web3 = new Web3(library?.currentProvider);
      const contract =
        chainId === supportedChains[0]
          ? new web3.eth.Contract(TOKEN_ERC20_ABI, TOKEN_ERC20)
          : new web3.eth.Contract(TOKEN_BEP20_ABI, TOKEN_BEP20);
      let allowance = await contract.methods
        .allowance(account, chainId === supportedChains[0] ? BRIDGE_ERC20 : BRIDGE_BEP20)
        .call();

      if (chainId ==supportedChains[0]) {
        setIsApprovedERC(allowance);
      } else {
        setIsApprovedBEP(allowance);
      }
      if(allowance!=0){
        setIsApproving(false)
      }
      setCheckApprovalButton(false);
    }
  };

  useEffect(async () => {
    setTaxPercentage(await calculateTaxFee())
    if (account) {
      await checkApproval();
    }
    if (active && library && account) {
      await getMContentBalance();
    }
  }, [account, chainId, active]);

  // useEffect(()=>{
  //   if(isApproving){
  //     // disabled={checkApprovalButton || approveLoading}
  //     setCheckApprovalButton(true);
  //   }
  //   console.log("isApproving: ",isApproving, checkApprovalButton)
  // },[isApproving]);

  useEffect(() => {
  }, [account, chainId, active]);

  const getMContentBalance = async () => {
    const web3 = new Web3(library?.currentProvider);
    const contract =
      chainId === supportedChains[0]
        ? new web3.eth.Contract(TOKEN_ERC20_ABI, TOKEN_ERC20)
        : new web3.eth.Contract(TOKEN_BEP20_ABI, TOKEN_BEP20);

    let balance = await contract.methods.balanceOf(account).call();
    setMContentBalance(web3.utils.fromWei(balance, "mwei"));
  };
  const handleWrongNetworkOpen = () =>{
    setWrongNetworkOpen(true)
  }
  const formatInput = (e) => {
    // Prevent characters that are not numbers ("e", ".", "+" & "-") ✨
    let checkIfNum;
    if (e.key !== undefined) {
      // Check if it's a "e", ".", "+" or "-"
      checkIfNum =
        e.key === "e" ||
        e.key === "E" ||
        // e.key === "." ||
        e.key === "+" ||
        e.key === "-";
    } else if (e.keyCode !== undefined) {
      // Check if it's a "e" (69), "." (190), "+" (187) or "-" (189)
      checkIfNum =
        e.keyCode === 69 ||
        // e.keyCode === 190 ||
        e.keyCode === 187 ||
        e.keyCode === 189;
    }
    return checkIfNum && e.preventDefault();
  };

  const handleApprove = (e) => {
    let tokenABI = chainId == supportedChains[0]? TOKEN_ERC20_ABI : TOKEN_BEP20_ABI;
    let tokenAddress = chainId == supportedChains[0]? TOKEN_ERC20 : TOKEN_BEP20;
    let bridgeAddress = chainId == supportedChains[0]? BRIDGE_ERC20 : BRIDGE_BEP20;
    if (chainId === supportedChains[0]|| chainId ===supportedChains[1]) {
      setApproveLoading(true);
      setIsApproving(true);
      const web3 = new Web3(library?.currentProvider);
      const contract = new web3.eth.Contract(tokenABI, tokenAddress);
      contract.methods
        .approve(
          bridgeAddress,
          web3.utils.toWei("10000000000000000000000000000000000000000")
        )
        .send({ from: account })
        .on("transactionHash", (hash) => {
          // hash of tx
        })
        .on("confirmation", async function (confirmationNumber, receipt) {
          if(receipt.status){
            if (confirmationNumber === 2){
            // tx confirmed
            checkApproval();
            setIsApprovedERC(1);
            setIsApprovedBEP(1);
            setApproveLoading(false);
            setIsApproving(false);
            setTriggerTransaction(!triggerTransaction)
          }}
        })
        .on("error", function (err) {
          // setApprovedLoading(false);
          setApproveLoading(false);
          setIsApproving(false);
          setTriggerTransaction(!triggerTransaction)
        });
    } else {
      alert("Change your network to ethereum testnet!");
    }
  };
let i = 0;
  const depositTokens = async () => {
    const web3 = new Web3(library?.currentProvider);
    const isAddressValid = web3.utils.isAddress(receivingAddress);
    if(isAddressValid){
      setInvalidReceiving(false);
    setPendingTransaction(true);
    setTransactionInProgress(true);
    let bridgeABI = chainId == supportedChains[0] ? BRIDGE_ERC20_ABI : BRIDGE_BEP20_ABI;
    let bridgeTokenAddress = chainId == supportedChains[0] ? BRIDGE_ERC20 : BRIDGE_BEP20;
    const contract = new web3.eth.Contract(bridgeABI, bridgeTokenAddress);
    contract.methods
      .depositTokens(
        web3.utils.toWei(
          /^[0-9]\d{0,15}(\.\d{0,6})*(,\d+)?$/.test(value)
            ? parseFloat(value).toString()
            : parseFloat(value).toFixed(6).toString(),
          "mwei"
        ),
        receivingAddress.toLowerCase()
      )
      .send({ from: account.toLowerCase() })
      .on("transactionHash", (hash) => {
        i = 1;
        setTransactionHash(hash);
      })
      .on("confirmation", async function (confirmationNumber, receipt) {
        if (receipt.status) {
          if (i < 10 && i > 0) {
            getClaimableAssets(await web3.eth.getAccounts());
          } else {
            i = 0;
          }
          if (confirmationNumber === 2) {
            setTransactionInProgress(false);
            // sendToClaim(1);
            // tx confirmed
            setMContentBalance(mContentBalance - value);
            setPendingTransaction(false);
            // sendToClaim(1);
            setTransationCompleted(true);
            setTriggerTransaction(!triggerTransaction)
          }
        }
      })
      .on("error", function (err) {
        setTransactionInProgress(false);
        setPendingTransaction(false);
        setTransactionError(true);
        setTriggerTransaction(!triggerTransaction)
      });
    // setPendingTransaction(false);
  }
  else{
    setInvalidReceiving(true);
  }
  };

  const handleChange = (e) => {
    const valueEntered = e.target.value;
    // setValue(valueEntered? new BigNumber(valueEntered):"");
    setValue(
      valueEntered
        ?new BigNumber(valueEntered).lt(1)?valueEntered: /^[0-9]\d{0,15}(\.\d{0,})*(,\d+)?$/.test(valueEntered)
          ?valueEntered
          : value
        : ""
    );

    // if (
    //   value &&
    //   new BigNumber(parseFloat(valueEntered)).gt(parseFloat(mContentBalance))
    // ) {
    //   console.log("Insuficient balance");
    // }

    // console.log("hello value: ", parseFloat(value));
  };
  const handleReceivingAddressChange = (e) =>{
const addressEntered = e.target.value;
setReceivingAddress(addressEntered);
if(invalidReceiving){
  const web3 = new Web3(library?.currentProvider);
  const isAddressValid = web3.utils.isAddress(receivingAddress);
  setInvalidReceiving(isAddressValid?true:false)
}
}

  const handleMaxValue = (e) => {
    setValue(new BigNumber(mContentBalance).valueOf());
  };

  return (
    <div>
      <div>
        <div className={classes.amountLabel}>
          <div>Enter Amount</div>
          <div style={{ textAlign: "right" }}>
            Balance:{" "}
            {millify(new BigNumber(mContentBalance).valueOf(), {
              precision: 4,
              lowercase: false,
            })}{" "}
            MCONTENT
          </div>
        </div>
        <div>
          <TextField
            className={classes.textFieldFullWidth}
            placeholder="Enter deposit amount"
            type="number"
            value={value ? value : ""}
            onChange={handleChange}
            onKeyDown={formatInput}
            disabled={checkApprovalButton || approveLoading ||isApproving || !account}
            inputProps={{ className: classes.input, maxLength: 12 }}
            InputProps={{
              inputProps: { min: 0 },
              disableUnderline: true,
              className: classes.amountInput,
              startAdornment: (
                <InputAdornment position="start">
                  <div style={{ display: "flex" }}>
                    <div
                     className={classes.inputStartIcon}
                    >
                      <img src={MContentIcon} height="35" width="35" />
                    </div>
                    <div>
                      <img src={VerticleLine} />
                    </div>
                  </div>
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="start">
                  <div className={`${classes.maxButton} ${(approveLoading ||isApproving || !account ||checkApprovalButton)&&classes.emptyAmount}`} onClick={handleMaxValue} style={{pointerEvents:`${(checkApprovalButton || approveLoading ||isApproving|| !account)?"none":""}`}}>
                    Max
                  </div>
                </InputAdornment>
              ),
            }}
          />
        </div>
        
      </div>
      <div>
        <div className={classes.amountLabel}>
          <div>Enter Address</div>
        </div>
        <div>
          <TextField
            className={`${classes.textFieldFullWidth}`}
            placeholder="Enter Wallet Address"
            type="text"
            value={receivingAddress ? receivingAddress : ""}
            onChange={handleReceivingAddressChange}
            disabled={checkApprovalButton || approveLoading ||isApproving|| !account}
            inputProps={{ className: classes.input, maxLength: 12 }}
            InputProps={{
              inputProps: { min: 0 },
              disableUnderline: true,
              className: classes.amountInputAddress,
            }}
          />
        </div>
        
      </div>
      <div style={{ display: "flex" }}>
        {chainId === supportedChains[0] ? (
          <div className={classes.width100}>
            <div className={classes.amountLabel}>From</div>
            <div className={classes.swapToken}>
              <div className={classes.tokenLogo}>
                <img src={EthereumLogo} alt="EthereumLogo" />
              </div>
              <div className={classes.tokenLabel}>ERC20</div>
            </div>
          </div>
        ) : (
          <div className={classes.width100}>
            <div className={classes.amountLabel}>From</div>
            <div className={classes.swapToken}>
              <div className={classes.tokenLogo}>
                <img src={BinanceLogo} alt="BinanceLogo" />
              </div>
              <div className={classes.tokenLabel}>BEP20</div>
            </div>
          </div>
        )}

        <div className={classes.swapIcon}>
          <IconButton onClick={() => switchNetwork(chainId === supportedChains[0] ? supportedChains[1]: supportedChains[0])} disabled={checkApprovalButton || approveLoading ||isApproving|| !account}>
            <img src={SwapIcon} alt="SwapIcon" />
          </IconButton>
        </div>

        {chainId === supportedChains[0] ? (
          <div className={classes.width100}>
            <div className={classes.amountLabel}>To</div>
            <div className={classes.swapToken}>
              <div className={classes.tokenLogo}>
                <img src={BinanceLogo} alt="BinanceLogo" />
              </div>
              <div className={classes.tokenLabel}>BEP20</div>
            </div>
          </div>
        ) : (
          <div className={classes.width100}>
            <div className={classes.amountLabel}>To</div>
            <div className={classes.swapToken}>
              <div className={classes.tokenLogo}>
                <img src={EthereumLogo} alt="EthereumLogo" />
              </div>
              <div className={classes.tokenLabel}>ERC20</div>
            </div>
          </div>
        )}
      </div>
      <div className={classes.amountLabel}>
        <div>Transaction Fee</div>
        <div style={{ textAlign: "right" }}> {gasPrice} USD</div>
      </div>
      <div className={classes.amountRemoveLabel}>
        <div>Receiving Amount</div>
        {(taxPercentage)&&<div style={{ textAlign: "right" }}> {
        millify(value * ((100-taxPercentage)/100), {
          precision: 4,
          lowercase: false,
        })} MContent</div>}
      </div>
      <div style={{ marginTop: "22px" }}>
        {active && account ? (
          chainId == supportedChains[0] ? (
            isApprovedERC == 0 ? (
              <Button
                className={`${classes.normalButton} ${classes.depositeButton}`}
                disabled={checkApprovalButton || approveLoading ||isApproving}
                fullWidth
                onClick={handleApprove}
                disableRipple
              >
                {(approveLoading || isApproving)?"Approving...":"Approve"}
              </Button>
            ) : (
         <DepositeButton value={value} mContentBalance={mContentBalance} pendingTransaction={pendingTransaction} depositTokens={depositTokens} invalidReceiving={invalidReceiving}/>
            )
          ) : isApprovedBEP == 0 ? (
            <Button
              className={`${classes.normalButton} ${classes.depositeButton}`}
              disabled={checkApprovalButton || approveLoading ||isApproving}
              fullWidth
              onClick={handleApprove}
              disableRipple
            >
              {(approveLoading || isApproving)?"Approving...":"Approve"}
            </Button>
          ) : (
           <DepositeButton  value={value} mContentBalance={mContentBalance} pendingTransaction={pendingTransaction} depositTokens={depositTokens} invalidReceiving={invalidReceiving} />
          )
        ) : (
          <ConnectWalletButton
            text={"Connect Wallet"}
            handleOpen={wrongNetwork? handleWrongNetworkOpen:handleOpen}
            handleClose={handleClose}
            open={open}
            padding={"10px 20px"}
          />
        )}
        <ConnectWalletModal
          handleOpen={handleOpen}
          handleClose={handleClose}
          open={open}
          text={"Connect Wallet"}
        />
      </div>
      <TransactionInProgress
        transactionInProgress={transactionInProgress}
        setTransactionInProgress={setTransactionInProgress}
        chainId={chainId}
        value={value}
        claimItem={false}
      />
      <TransactionError
        transactionError={transactionError}
        setTransactionError={setTransactionError}
      />
      <TransactionSuccessfull
      claimItem={false}
        transactionCompleted={transactionCompleted}
        transactionHash={transactionHash}
        setTransactionHash={setTransactionHash}
        setTransationCompleted={setTransationCompleted}
        setValue={setValue}
        chainId={chainId}
        value={value}
        height={"360px"}
        type={"deposite"}
        sendToClaim={sendToClaim}
      />
       <WrongNetworkModal wrongNetworkOpen={wrongNetworkOpen} setWrongNetworkOpen={setWrongNetworkOpen} />
    </div>
  );
}

export default Create;
